import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDPrimaryActionButton, FDSecondaryActionButton } from '@facet-wealth/design';
import { useChiliPiperContext } from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperContext';
import { dataAttrs } from 'Helpers/Testing';
import ChiliPiperComponentInFullScreenDialog
  from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperComponentInFullScreenDialog';
import { noop } from 'Helpers/PropTypes';
import Relationship from 'facet-rest/src/domain/Relationship';

const ScheduleMeetingInChiliPiperButton = ({
  resource,
  onRedirect,
  isPrimary,
  size,
  scheduleChiliPiperMeetingRelationship,
}) => {
  const {
    setOpenIFrame, showChiliPiperComponent, chiliPiperRel, handleChiliPiperExit,
  } = useChiliPiperContext(resource, onRedirect, scheduleChiliPiperMeetingRelationship.attr('name'));

  const ButtonComponent = isPrimary ? FDPrimaryActionButton : FDSecondaryActionButton;

  return (
    (showChiliPiperComponent ? (
      <ChiliPiperComponentInFullScreenDialog chiliPiperRel={chiliPiperRel} handleChiliPiperExit={handleChiliPiperExit} />
    )
      : <ButtonComponent
        isFullWidth
        onClick={() => setOpenIFrame(true)}
        label={scheduleChiliPiperMeetingRelationship.meta('prompt')}
        size={size}
        {...dataAttrs('schedule-meeting-in-chili-piper-button')}
      />
    )
  );
};

ScheduleMeetingInChiliPiperButton.defaultProps = {
  onRedirect: noop,
  isPrimary: true,
  size: 'md',
};

ScheduleMeetingInChiliPiperButton.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  onRedirect: PropTypes.func,
  isPrimary: PropTypes.bool,
  size: PropTypes.string,
  scheduleChiliPiperMeetingRelationship: PropTypes.instanceOf(Relationship).isRequired,
};

export default ScheduleMeetingInChiliPiperButton;
